import RadioGroup from '@components/Form/RadioGroup';
import { FormField } from '@/types';

function RadioField(props: FormField) {
  const { label, clean_name: cleanName, choices, required } = props;

  return (
    <RadioGroup
      required={required}
      id={cleanName}
      label={label}
      items={choices.map(choice => ({ label: choice, value: choice }))}
    />
  );
}

export default RadioField;
